import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login, { Register } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CourseDetail from "@/pages/CourseDetail";
import LessonPlayer from "@/pages/LessonPlayer";
import Catalog from "@/pages/Catalog";
import Admin from "@/pages/Admin";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500" data-testid="protected-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{from: loc.pathname}} replace/>;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace/>;
  return children;
}

function Router() {
  // Process Google session_id BEFORE other routes — synchronous detection
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback/>;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing/>}/>
      <Route path="/login" element={<Login/>}/>
      <Route path="/register" element={<Register/>}/>
      <Route path="/dashboard" element={<Protected><Dashboard/></Protected>}/>
      <Route path="/catalog" element={<Protected><Catalog/></Protected>}/>
      <Route path="/courses/:courseId" element={<Protected><CourseDetail/></Protected>}/>
      <Route path="/courses/:courseId/lessons/:lessonId" element={<Protected><LessonPlayer/></Protected>}/>
      <Route path="/admin" element={<Protected role="admin"><Admin/></Protected>}/>
      <Route path="*" element={<Navigate to="/" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Router/>
      </AuthProvider>
    </BrowserRouter>
  );
}
